// ./src/contexts/ArtistsContext/ArtistsContext.tsx
//
// Thin context wrapper around the useArtists hook. All derived data lives in the
// hook itself. Mirrors InventoryItemsContext — mounted on the account Library page
// and (with an eventId) wherever an artist picker needs to list + create in place.

import React, { createContext, useContext } from "react";

import { useArtists, UseArtistsOptions, UseArtistsReturn } from "@/hooks/useArtists";

const ArtistsContext = createContext<UseArtistsReturn | null>(null);

export interface ArtistsProviderProps extends UseArtistsOptions {
  children: React.ReactNode;
}

export const ArtistsProvider: React.FC<ArtistsProviderProps> = ({ children, ...options }) => {
  const value = useArtists(options);

  return <ArtistsContext.Provider value={value}>{children}</ArtistsContext.Provider>;
};

export const useArtistsContext = (): UseArtistsReturn => {
  const context = useContext(ArtistsContext);

  if (!context) {
    throw new Error(
      "useArtistsContext must be used within an <ArtistsProvider>. " +
        "Wrap your component tree with <ArtistsProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalArtistsContext = (): UseArtistsReturn | null => {
  return useContext(ArtistsContext);
};
